module.exports = __webpack_public_path__ + "img/USP_Icons-Swift-Global-Delivery.a23bea2.png";